export type FleetTrailerStatus = 'AVAILABLE' | 'ASSIGNED' | 'MAINTENANCE' | 'OUT_OF_SERVICE' | 'INACTIVE';

export interface FleetTrailerType {
    trailerTypeId?: number;
    owningCompanyId?: number;
    code?: string;
    name?: string;
    description?: string;
    active?: boolean;
    sortOrder?: number;
    activeTrailerCount?: number;
    createdAt?: string | Date;
    updatedAt?: string | Date;
}

export interface FleetTrailer {
    trailerId?: number;
    assetNumber?: string;
    owningCompanyId?: number;
    transportationAgencyId?: number;
    trailerTypeId?: number;
    trailerTypeCode?: string;
    trailerTypeName?: string;
    plateNumber?: string;
    registrationNumber?: string;
    registrationExpiry?: string | Date;
    insuranceExpiry?: string | Date;
    status?: FleetTrailerStatus | string;
    active?: boolean;
    notes?: string;
    createdAt?: string | Date;
    updatedAt?: string | Date;
}

export interface FleetTrailerTypeSearchParams {
    owningCompanyId: number;
    page?: number;
    pageSize?: number;
    active?: boolean | null;
    keyword?: string;
}

export interface FleetTrailerSearchParams {
    owningCompanyId: number;
    page?: number;
    pageSize?: number;
    active?: boolean | null;
    status?: FleetTrailerStatus | string | '';
    trailerTypeId?: number;
    transportationAgencyId?: number;
    keyword?: string;
}

export const FLEET_TRAILER_STATUS_OPTIONS = [
    { label: 'Available', value: 'AVAILABLE' },
    { label: 'Assigned', value: 'ASSIGNED' },
    { label: 'Maintenance', value: 'MAINTENANCE' },
    { label: 'Out of Service', value: 'OUT_OF_SERVICE' },
    { label: 'Inactive', value: 'INACTIVE' }
];

export const FLEET_ACTIVE_OPTIONS = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false }
];
